import React from 'react';

const Returns = () => {
  return <>ManageOrder - Returns Screen</>;
};

export default Returns;
